import EnvironmentConfig from './common/EnvironmentConfig';

/**
 * Starts downloading the AWS entities file while the main bundle still loads,
 * so the app finds it cached.
 */
function preloadEntities() {
  const href = EnvironmentConfig.getConfig().entitiesEndpoint;
  if (!href) {
    return;
  }

  // Match the app's fetch() call (CORS, no cookies), or the browser downloads the file twice
  const link = document.createElement('link');
  link.rel = 'preload';
  link.as = 'fetch';
  link.crossOrigin = 'anonymous';
  link.href = href;
  document.head.appendChild(link);
}

preloadEntities();
